import { ArticleDetail } from '@src/components/sco/Education/ArticleDetail'
import { useEducationContext } from '@src/components/sco/Education/EducationContext'
import { useUniversalEffect } from '@src/hooks/useUniversalEffect'
import { EducationPage } from '@src/templates/EducationPage'
import { useParams } from 'next/navigation'

export { getServerSideProps } from '@src/lib/server-side-rendering'

export default EducationPage(function Page() {
  const educationContext = useEducationContext()
  const routeParams = useParams() as Record<string, string | undefined> | null

  useUniversalEffect(() => {
    educationContext.setBreadcrumbs?.([{ title: 'Founder Interviews', href: '/founder-interviews' }])
    educationContext.setActiveSection?.('founder-interviews.single')
  }, [])

  return (
    <ArticleDetail
      articleSlug={`${routeParams?.slug}`}
      typeSlug={'founder-interviews'}
      typeTitle={'Founder Interviews'}
    />
  )
})
